<template>
  <section class="prescription" @click="goPrescriptionDetail(prescription)">
    <div class="prescription__content">
      <div class="flex align-center prescription__info space-between">
        <h4 class="flex">
          <span class="flex-1 van-ellipsis">{{ prescription.name }}</span>
          <span>{{ prescription.age }}岁</span>
          <span>{{ prescription.gender | sex }}</span>
        </h4>
        <span class="prescription__create-time flex-1">
          {{ prescription.orderTime | parseDate }}
        </span>
      </div>
      <!-- <p class="prescription__illness van-ellipsis">疾病诊断：{{ prescription.illness }}</p> -->
      <h2>
        <!-- <img
          width="18"
          height="17.5"
          class="rp_img"
          src="https://static.91jkys.com/third_files/GuoYao/202010/16/a892987ca1c14889aa8bd36f655b1a1b.png"
          alt="rp"
        /> -->
      </h2>
      <p
        class="prescription__drug flex space-between"
        :class="{
          'prescription__drug--more': prescription.detailModelList.length > 1
        }"
      >
        <span class="prescription__drug__name van-ellipsis flex-1">
          {{ prescription.detailModelList[0] && prescription.detailModelList[0].name }}
        </span>
        <span>x{{ prescription.detailModelList[0] && prescription.detailModelList[0].num }}</span>
      </p>
    </div>
    <label class="prescription__expried-status" v-if="prescription.status === STATUS_MAP.EXPIRED">处方已过期</label>
  </section>
</template>

<script>
export default {
  props: {
    prescription: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      STATUS_MAP: { EXPIRED: 'EXPIRED' }
    };
  },
  methods: {
    // eslint-disable-next-line class-methods-use-this
    goPrescriptionDetail({ id }) {
      this.$router.push({
        path: '/recipe-view',
        query: { id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@gray-3: #ebebeb; //二级边框
@gray-6: #adadad; //次要文字
@gray-7: #707070; //常规文字
@font-size-sm: 12px;
@font-size-md: 14px;
.prescription {
  background-color: white;
  padding: 20px 16px;
  border-top: 1px solid @gray-3;
  position: relative;

  &__info {
    margin-bottom: 8px;
    h4 {
      span + span {
        margin-left: 8px;
      }
    }
  }

  &__create-time {
    color: @gray-6;
    font-size: @font-size-sm;
    white-space: nowrap;
    text-align: right;
  }

  &__illness {
    color: @gray-7;
  }

  h2 {
    margin: 17px 0 20px;
  }

  &__expried-status {
    position: absolute;
    right: 11px;
    bottom: 58px;
    color: #ccc;
    border: 2px solid currentColor;
    padding: 7px 10px;
    font-size: @font-size-sm;
    transform: rotate(-10deg);
  }

  &__drug {
    padding-bottom: 16px;
    position: relative;

    &--more {
      &::after {
        content: '...';
        position: absolute;
        bottom: -8px;
      }
    }

    &__name {
      padding-right: 10px;
    }
  }
}
</style>
